module.exports = __webpack_public_path__ + "assets/img/money.009f1df7.svg";